import { SettingsCard } from '../common';

/**
 * Placeholder content for the "Billing" settings tab. Payment collection isn't
 * live yet — every user is on a free trial — so instead of real subscription
 * and payment-method controls this shows a single card noting the free-trial
 * state. Purely presentational; holds no data.
 */
const BillingSettings = () => (
  <div className="flex max-w-[736px] flex-col gap-5">
    <SettingsCard title="Plan & billing" subtitle="Your subscription and payment details.">
      <div className="flex flex-col gap-1">
        <p className="text-quaternary text-xs font-semibold uppercase tracking-wide">Current plan</p>
        <p className="text-primary text-md font-medium">Free trial</p>
        <p className="text-tertiary text-sm">
          You're on a free trial and haven't been charged. Subscription and billing management will be available here
          soon.
        </p>
      </div>
    </SettingsCard>
  </div>
);

BillingSettings.displayName = 'BillingSettings';

export default BillingSettings;
